import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

import './header.css'
import Plant from './plant.js'

export default class Header extends Component {

  constructor(props) {
    super(props)

    // this.state = {
    //
    // }

    this.drawPlant = this.drawPlant.bind(this)
  }

  drawPlant(canvasElement) {
    // TODO: Clean up the Header so it actually removes all Plant references
    if (canvasElement) {
      Plant.init(canvasElement);
      Plant.draw();
    }
  }

  render() {
    // Super obvious, but no one does this because they're out of it:
    const { className } = this.props;

    return (
      <div className={classnames('header', className)}>
        <Link to="/" className="header_art">
          <canvas className='main_canvas' ref={this.drawPlant}>
            This text is displayed if your browser does not support HTML5 Canvas.
          </canvas>
          <div className='page_title'>zenpirate</div>
        </Link>

        <div className="control_holder">
          <div className="navigation">
            <Link to="/">Home</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/about">About</Link>
            <Link to="/projects">Projects</Link>
            <Link to="/login">Login</Link>
            {/*<Link to="/404-test">404test</Link>*/}
          </div>
          <div className="controls">
            {/*TODO: Finish adding controls for current user*/}
          </div>
          <div className="messages">
            {/*TODO: Finish adding user messaging*/}
          </div>
        </div>
      </div>
    )
  }
}


Header.propTypes = {
  someValue: PropTypes.number
}



// WEBPACK FOOTER //
// ./src/components/Header/index.js